// 热词管理
import http from "@/jslibs/axios/http";

// 列表
export const page = (data) => http.post("/web/CommunityManager/getHotWordList", data);

// 新增
export const add = (data) => http.post("/web/CommunityManager/addHotWord", data);

// 删除
export const del = (data) => http.post("/web/CommunityManager/deleteHotWord", data);

// 详情
export const detail = (data) => http.post("/web/CommunityManager/getHotWordDetail", data);

// 编辑 
export const edit = (data) => http.post("/web/CommunityManager/updateHotWord", data);